<template>
    <div>
        <div class="data-table">
            <Schedule v-for="schedule in schedules.data" :key="schedule.id" :schedule="schedule" :type="type"></Schedule>
        </div>

        <Pagination :pagination="schedules.meta" @paginate="changePage" :offset="4" :arrows="false"></Pagination>
    </div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import Pagination from '@/components/global/Pagination'
	import Schedule from '@/components/schedule/Schedule'

	export default {
		components: { Schedule, Pagination },

		props: ['schedules', 'type'],

		computed: {
			...mapGetters([
				'currentUser',
			]),
		},

		methods: {
//            fetchData(page = 1) {
//                this.$store.dispatch(SET_LOADING, true);
//
//                this.$store.dispatch(FETCH_PROJECTS, {page: page}).then(() => {
//                    this.$store.dispatch(SET_LOADING, false);
//                });
//            },

			changePage () {
				this.$emit('changePage', this.schedules.meta.current_page)
			},
		},
	}
</script>